<template>
    <div>
        <b-card-text style="font-size: 20px; text-align: center;">STORE STOCK TRANSFER</b-card-text>
        <b-tabs card>
            <b-tab title="LIST/ADD ORDERS" style="padding: 5px;">
                <ListTransferOrders />
            </b-tab>

             <b-tab title="AS IS ORDERS" style="padding: 5px;">
                <ListDamageOrders />
            </b-tab>

            <!-- <b-tab title="PULL ORDERS" style="padding: 5px;">
                <PullTransferOrders />
            </b-tab> -->



            <!-- <b-tab title="SHIPPING" style="padding: 5px;">
                <OutgoingTransferOrders />
            </b-tab> -->

            <!-- <b-tab  v-if="[
                    'locationadmin',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)"  title="SHIPPING" style="padding: 5px;">
                <ShippingTransferOrder />
            </b-tab>

            <b-tab   v-if="[
                    'locationadmin',
                    'warehouseuser',
                    'warehousemanager'
                ].includes(packet.userDetails.userrole)" title="RECIEVING" style="padding: 5px;">
                <RecievingTransferOrder />
            </b-tab> -->

            <!-- <b-tab title="DELIVERY" style="padding: 5px;">
                <DeliverTransferOrders />
            </b-tab> -->
<!-- 
            <b-tab title="RECEIVING" style="padding: 5px;">
                <IncomingTransferOrders />
            </b-tab> -->

        </b-tabs>
    </div>
</template>

<script>
    //import ItemComments from '@/components/importables/ItemComments'
    import ListTransferOrders from '@/components/TransferOrders/ListTransferOrders'
    import PullTransferOrders from '@/components/TransferOrders/PullTransferOrders'
    import DeliverTransferOrders from '@/components/TransferOrders/DeliverTransferOrders'
    import IncomingTransferOrders from '@/components/TransferOrders/IncomingTransferOrders'
    import OutgoingTransferOrders from '@/components/TransferOrders/OutgoingTransferOrders'
    import ShippingTransferOrder from '@/components/TransferOrders/ShippingTransferOrder'
    import RecievingTransferOrder from '@/components/TransferOrders/RecievingTransferOrder'
    import ListDamageOrders from '@/components/TransferOrders/ListDamageOrders'

    export default {
        name: "TransferOrdersMain",
        components: {ListTransferOrders, ListDamageOrders, PullTransferOrders, DeliverTransferOrders, IncomingTransferOrders, OutgoingTransferOrders,ShippingTransferOrder,RecievingTransferOrder},
        data: function(){
            return {}
        },
        methods: {},
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        }

    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TransferOrders/TransferOrdersMain.vue